import { jsx as _jsx } from "react/jsx-runtime";
import { useAppSelector } from "@application/store/useStore";
import { Container } from "@mui/material";
import { Outlet, useLocation } from "react-router-dom";
import { Navigate } from "react-router-dom";
export const ProtectedRoute = ({ children, permissions = [], isAdminRoute = false, }) => {
    const { linkVerification } = useAppSelector((state) => state.event);
    const { pathname } = useLocation();
    const { currentUser } = useAppSelector((state) => state.auth);
    if (!currentUser && isAdminRoute)
        return _jsx(Navigate, { to: "/admin/login", state: { pathname } });
    if (!isAdminRoute &&
        (linkVerification === null || linkVerification === undefined)) {
        return _jsx(Navigate, { to: "/invalid-link/unauthorized" });
    }
    return (_jsx(Container, { maxWidth: false, sx: {
            paddingLeft: { xs: "0px", sm: "16px" },
            paddingRight: { xs: "0px", sm: "16px" },
        }, children: children ? children : _jsx(Outlet, {}) }));
};
